module.exports = require("crx-parser");